export default __webpack_public_path__ + "static/tmb-4-d86a10604e193d5a60e0cc5e39cd45ef.png";